import { styled, ToggleButtonGroup } from '@mui/material';

const StyledToggleButtonGroup = styled(ToggleButtonGroup)({
  '& .MuiButtonBase-root:first-child': {
    borderTopLeftRadius: "8px",
    borderBottomLeftRadius: "8px",
  },
  '& .MuiButtonBase-root:last-child': {
    borderTopRightRadius: "8px",
    borderBottomRightRadius: "8px",
  },
  '& .MuiButtonBase-root.MuiToggleButton-root.Mui-selected': {
    borderColor: '#1976d2',
  },
});

export default StyledToggleButtonGroup;